import { observable } from "mobx";
import { Type } from "class-transformer";
import ChargeValidityInstructionGroupResponse from "./chargeValidityInstructionGroupResponse";
import ChargeValidityOverlapInstructionsGroupResponse from "./chargeValidityOverlapInstructionsGroupResponse";

// This entity has been generated, do not change its content, your changes might get lost. You CAN modify the rest of the file.
export default class ChargeValidityInstructionGroupsResponse {
  /**
   * The list of validity instructions.
   */
  @observable
  @Type(() => ChargeValidityInstructionGroupResponse)
  validities!: ChargeValidityInstructionGroupResponse[];

  /**
   * The list of overlap instructions.
   */
  @observable
  @Type(() => ChargeValidityOverlapInstructionsGroupResponse)
  overlaps!: ChargeValidityOverlapInstructionsGroupResponse[];
}
